

import {Component, Vue} from "vue-property-decorator"
import config from "@/config";
import type {ICrudOption} from "@/types/m-ui-crud"
import {IPage} from "@/apis/page";
import {checkoutApi, fruitTreeQueryApi, procurementCheckinApi} from "@/apis/linye";

@Component({})
export default class JobStock extends Vue {
  config = config
  // 表格加载状态
  tableLoading: boolean = true;
  // 表格数据
  tableData: any[] = []
  // 表格总数
  tableTotal = 0
  // 查询参数
  queryParam: IPage = {
    page: 1,
    limit: 10
  }
  // 表单参数
  modelForm: Partial<any> = {}
  // crud配置信息
  crudOption: ICrudOption = {
    delBtn: false,
    searchBox: true,
    dialogWidth: '70%',
    labelWidth: '150px',
    column: [
      {
        label: "ID",
        type: "index",
        prop: "id",
        align: "center",
        width: 50,
        addHide: true,
        editHide: true
      },
      {
        label: "种植园名称",
        prop: "plantationName",
        align: "center",
        placeholder: "请输入种植园名称",
        width: '150px',
        search: true,
        addHide: true,
        editHide: true
      },
      {
        label: "品种名称",
        prop: "name",
        align: "center",
        placeholder: "请输入品种",
        search: true,
        addHide: true,
        editHide: true
      },
      {
        label: "库存（KG）",
        prop: "stock",
        align: "center",
        search: false,
        addHide: true,
        editHide: true
      },
    ]
  }

  checkinDialog: boolean = false
  checkinForm: any = {}

  checkoutDialog: boolean = false
  checkoutForm: any = {}

  getList() {
    this.tableLoading = true
    fruitTreeQueryApi(this.queryParam).then(e => {
      this.tableData = e.list
      this.tableTotal = e.total
      this.tableLoading = false
    })
  }

  openCheckout(row: any, index: number) {
    this.checkoutDialog = true
    this.checkoutForm.fruitTreeId = row.id
  }

  checkoutEnter(done: Function, loading: Function) {
    // @ts-ignore
    this.$refs.checkoutRef.validate(valid => {
      if (valid) {
        checkoutApi(this.checkoutForm).then(e => {
          if (e) {
            this.getList()
            this.$message.success("操作成功!")
            done()
          }
        }).finally(() => {
          loading()
        })
      } else {
        loading()
      }
    })
  }

  checkoutClose() {
    this.checkoutForm = {}
  }

  openCheckin(row: any, index: number) {
    this.checkinDialog = true
    this.checkinForm.fruitTreeId = row.id
  }

  checkinEnter(done: Function, loading: Function) {
    // @ts-ignore
    this.$refs.checkinRef.validate(valid => {
      if (valid) {
        procurementCheckinApi(this.checkinForm).then(e => {
          if (e) {
            this.getList()
            this.$message.success("操作成功!")
            done()
          }
        }).finally(() => {
          loading()
        })
      } else {
        loading()
      }
    })
  }

  checkinClose() {
    this.checkinForm = {}
  }


  created() {
    this.getList()
  }
}
